import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../../Context/AuthContext";
import "./BackgroundManager.css";

const API = process.env.REACT_APP_API || window.location.origin;

export default function BackgroundManager() {
  const { token } = useAuth();
    
  const [page, setPage] = useState("home"); // home | leagues | tournaments
  const [images, setImages] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchImages = async (selectedPage) => {
    try {
      const res = await axios.get(`${API}/api/backgrounds/${selectedPage}`);
      setImages(res.data);
    } catch (err) {
      console.error(err);
      toast.error("שגיאה בשליפת התמונות");
    }
  };

  useEffect(() => {
    fetchImages(page);
  }, [page]);

  const handleUpload = async () => {
    if (selectedFiles.length === 0) return toast.error("בחר/י קובץ קודם");

    const formData = new FormData();
    Array.from(selectedFiles).forEach((file) => formData.append("image", file));

    setLoading(true);

    try {
      await axios.post(`${API}/api/backgrounds/upload/${page}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data", 
            Authorization: `Bearer ${token}`
        },
      });
      toast.success("התמונה/ות נשמרה/ו בהצלחה!");
      setSelectedFiles([]);
      fetchImages(page);
    } catch (err) {
        console.error(err);
        toast.error("שגיאה בהעלאה");
    } finally {
        setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("את/ה בטוח/ה שברצונך למחוק את התמונה?")) return;

    try {
      await axios.delete(`${API}/api/backgrounds/${id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`, // 👈 חובה
        },
      });
      toast.success("התמונה נמחקה בהצלחה");
      setImages(images.filter((img) => img._id !== id));
    } catch (err) {
      console.error(err);
      toast.error("שגיאה במחיקה");
    }
  };

  return (
    <div className="background-manager">

      <label>בחר עמוד:</label>
      <select value={page} onChange={(e) => setPage(e.target.value)} className="select-page">
        <option value="home">עמוד הבית</option>
        <option value="leagues">ליגות</option>
        <option value="teams">קבוצות (פרטים)</option>
        <option value="tournaments">טורנירים</option>
        <option value="dailyTournaments">טורנירים יומיים</option>
        <option value="eilatTournaments">טורנירי אילת</option>
      </select>

      <div className="mb-3">
        <input
            type="file"
            multiple
            name="background"
            onChange={(e) => setSelectedFiles(e.target.files)}
        />
      </div>

        <button
            onClick={handleUpload}
            disabled={loading}
            className="upload-btn-backgroundManager"
        >
            {loading ? "מעלה..." : "העלאת תמונות"}        
        </button>
      <div className="images-grid">
        {images.map((img) => (
          <div key={img._id} className="image-item">
            <img src={img.url} alt="" />
            <button
              className="delete-btn"
              onClick={() => handleDelete(img._id)}
            >
              ✖
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
